import React from 'react';
import {PropTypes} from 'prop-types';
import {useModel} from './use_model.js';
import {Loader} from "../elements/loader.js";

/*  ModelConsumer takes a function as a child, it sends one argument, the data returned by the model.
 *  At least one prop is required, the model. Additinally you can provide your own callback function to
 *  retrieve the data from the model.
*/
const ModelConsumer = function (props) {
    const data = useModel(props.model, props.callback, props.selectionCriteria);

    if (data.status === props.model.Status.INACTIVE ||
            data.status === props.model.Status.WAITING) {
        return <Loader/>
    } else if (data.status === props.model.Status.FAILED) {
        return <div>
            <p>
                Something went wrong!
                <br/>
                Error: {data.error ? data.error : 'Unknown error'}
            </p>
        </div>
    } else if (data.status === props.model.Status.SUCCESS) {
        return <>
            {props.children(data)}
        </>;
    }


}

ModelConsumer.defaultProps = {
    callback: (model) => (model.getData()),
    selectionCriteria: null
};

ModelConsumer.propTypes = {
    model: PropTypes.func.isRequired,
    callback: PropTypes.func,
    selectionCriteria: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    children: PropTypes.func.isRequired,
};

export {ModelConsumer};
